import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock,
    BlockType,
    SettingType,
    TibboDataType,
    IOMode,
} from '@appblocks/codegeneration/types';
import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';

export default class Tibbit_15 extends IOTibbit {
    constructor() {
        super();
        this.id = 'tibbit_15';
        this.name = 'Tibbit 15';
        this.lines = 1;
        this.mode = IOMode.OUTPUT;
        this.initLines();
    }
}
